export class FormFieldChanged {
  constructor(name, value, oldValue, groupName, groupIndex, elementId, saveAsBatch) {
    this.name = name;
    this.value = value;
    this.oldValue = oldValue;
    this.groupName = groupName;
    this.groupIndex = groupIndex;
    this.elementId = elementId;
    this.saveAsBatch = saveAsBatch;
  }
}
